import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {StandardPage} from "../../Common/pages/StandardPage";
import SectionPlainTitle from "../../Common/components/SectionPlainTitle";
import {RightColumn} from "../../Common/pages/RightColumn";

@connect(state => ({ morenews: state.common.morenews}))
export default class CustomBasketLayout extends Component {
  static propTypes = {
    CustomBasketNews: PropTypes.element.isRequired,
    location: PropTypes.object.isRequired,
  };

  render() {
    const {
      location,
      CustomBasketNews,
    } = this.props;

    return (
      <div className="horse-profile-page">
        <StandardPage sport="racing" title="Columnists">
          <div className="main-layout-block">
            <SectionPlainTitle className="page-main-section-title" level={1}>Columnists</SectionPlainTitle>
          </div>
          <div className="main-layout-left-column">
            {CustomBasketNews}
          </div>

          <RightColumn location={location}
                       sport="racing"
                       content={
                         ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"]} />
        </StandardPage>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/News/containers/CustomBasketLayout.js